import isLength from 'validator/lib/isLength';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isEmail from 'validator/lib/isEmail';
import isNumeric from 'validator/lib/isNumeric';
import { i18n } from '../main';

export default {
  validPhone: {
    expression(field, model, next) {
      next(isMobilePhone(model[field.key], 'any'));
    },
    message: i18n.t('validation.phone')
  },
  validString: {
    expression: (field, model, next) => {
      next(isLength(model[field.key], 3));
    },
    message: i18n.tc('validation.min', 3)
  },
  validPassword: {
    expression(field, model, next) {
      next(isLength(model[field.key], { min: 6 }));
    },
    message: i18n.tc('validation.min', 6)
  },
  validConfirmationPassword: {
    expression: (field, model, next) => {
      next(model[field.key] === model.password);
    },
    message: i18n.t('validation.confirmed')
  },
  validEmail: {
    expression(field, model, next) {
      next(isEmail(model[field.key]));
    },
    message: i18n.t('validation.email')
  },
  validConfirmationEmail: {
    expression: (field, model, next) => {
      next(model[field.key] === model.email);
    },
    message: i18n.t('validation.confirmed')
  },
  validNumber: {
    expression(field, model, next) {
      const value = model[field.key] + '';
      next(isNumeric(value) || value === 'null' || value === '');
    },
    message: i18n.t('validation.number')
  },
  needToBeTrue: {
    expression(field, model, next) {
      next(model[field.key]);
    },
    message: i18n.t('validation.needToBeTrue')
  }
};
